import { FEATURE_STATUS } from "features/Account/Account.constants";
import { getOptimisedS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import { MailLink } from "features/Common/modules/MailLink/MailLink";
import React from "react";
import { AccessRequestedTitle } from "../components/AccessRequestedTitle";

export const REQUEST_VERIFICATION_KRA_CONFIG = {
  // default fallback
  default: {
    text: {
      title: "KRA verification required to enable centralized KYC management.",
      color: "#033c4a",
    },
    backgroundColor: "#eef8ff",
    btn: {
      type: "submit",
      color: "#0f619c",
      btnText: "Request Verification",
    },
  },
  // to request
  [FEATURE_STATUS.ACCESS_LOCKED]: {
    text: {
      title: "KRA verification required to enable centralized KYC management.",
      color: "#033c4a",
    },
    backgroundColor: "#eef8ff",
    btn: {
      type: "submit",
      color: "#0f619c",
      btnText: "Request KRA Verification",
    },
  },
  // requested
  [FEATURE_STATUS.ACCESS_REQUESTED]: {
    text: {
      title: (config) => <AccessRequestedTitle config={config} />,
      color: "#473905",
    },
    backgroundColor: "#FFF7DA",
    btn: {
      color: "#473905",
      btnText: "Verification in progress...",
      className: "inProgressBtn",
      icon: getOptimisedS3AssetCDNUrl("Account/in_progress.png"),
    },
  },
  // failed
  [FEATURE_STATUS.ACCESS_DENIED]: {
    text: {
      title: (
        <>
          KRA verification has failed. Retry or contact <MailLink /> for any
          queries.
        </>
      ),
      color: "rgba(39, 37, 34, 0.80)",
    },
    backgroundColor: "#F2F2F2",
    btn: {
      type: "submit",
      color: "rgba(39, 37, 34, 0.85)",
      btnText: "Retry Verification",
    },
  },
  // granted
  [FEATURE_STATUS.ACCESS_GRANTED]: {
    text: {
      title: (
        <span>
          KRA verification completed successfully! You can enable KRA flow at
          offering level from Manage Offering
        </span>
      ),
      color: "#28a745",
    },
    backgroundColor: "#d4edda",
    btn: {
      hidden: true,
      type: "submit",
      color: "#28a745",
      btnText: "View Documents",
    },
  },
};

export const REQUEST_KRA_CONTENT_CONSTANTS = {
  CVL_INDIA_EMAIL: "api_integration@cvlindia.com",
  NDML_WEBSITE: "https://kra.ndml.in",
  CVL_WEBSITE: "https://www.cvlkra.com",
  EXLY_BACKEND_IPS: ["13.126.198.236", "52.66.66.81"],
};
